import type { Template } from "@/types";

export const LA_03_H0_V3: Template[] = [
    {
        id: "la-03-h0v3-01",
        name: "LA 01 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_01.png",
        size: [1352, 483],
        style: {},
        slots: [          
            { id: "1", x: 57, y: 44, width: 277, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 44, width: 277, height: 395, rotation: 0, imageRotation: 0 },
            { id: "3", x: 849, y: 0, width: 348, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-02",
        name: "LA 02 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_02.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 57, y: 44, width: 277, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 44, width: 277, height: 395, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1016, y: 44, width: 277, height: 395, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-03",
        name: "LA 03 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 166, y: 0, width: 348, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 789, y: 76, width: 235, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1031, y: 76, width: 234, height: 330, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-04",
        name: "LA 04 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 233, y: 90, width: 208, height: 321, rotation: 0, imageRotation: 0 },
            { id: "2", x: 799, y: 90, width: 208, height: 321, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1015, y: 90, width: 207, height: 321, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-05",
        name: "LA 05 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 92, y: 56, width: 260, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 360, y: 56, width: 260, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 628, y: 56, width: 260, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-06",
        name: "LA 06 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 278, y: 56, width: 260, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 56, width: 260, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 814, y: 56, width: 260, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-07",
        name: "LA 07 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 315, y: 74, width: 236, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 559, y: 74, width: 235, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 802, y: 74, width: 235, height: 336, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-08",
        name: "LA 08 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_08.png",
        size: [1352, 483],
        style: {},
        slots: [  
            { id: "1", x: 46, y: 38, width: 288, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 38, width: 288, height: 406, rotation: 0, imageRotation: 0 },
            { id: "3", x: 873, y: 38, width: 289, height: 406, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-09",
        name: "LA 09 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 47, y: 38, width: 288, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 841, y: 79, width: 229, height: 323, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1078, y: 79, width: 228, height: 323, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-10",
        name: "LA 10 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h0_v3_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 141, y: 72, width: 233, height: 357, rotation: 0, imageRotation: 0 },
            { id: "2", x: 506, y: 0, width: 340, height: 483, rotation: 0, imageRotation: 0 },
            { id: "3", x: 977, y: 72, width: 233, height: 357, rotation: 0, imageRotation: 0 }
        ],
    },
];